import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

function SingleInsight() {

  const { slug } = useParams();

  const [post, setPost] = useState(null);

  // FETCH SINGLE POST
  const getPost = async () => {

    try {

      const res = await axios.get(
        `http://localhost:5000/api/posts/slug/${slug}`
      );

      setPost(res.data);

    } catch (err) {

      console.log(err);

    }

  };

  useEffect(() => {

    getPost();

  }, [slug]);

  // LOADING
  if (!post) {

    return (
      <section className="min-h-screen flex items-center justify-center px-6">
        <h1 className="text-2xl md:text-3xl font-bold text-center">
          Loading article...
        </h1>
      </section>
    );

  }

  return (
    <section className="bg-[#F8F8F8] min-h-screen pb-16 md:pb-24">

      {/* HERO SECTION */}
      <div className="relative h-[55vh] md:h-[70vh] overflow-hidden">

        {/* IMAGE */}
        <img
          src={`http://localhost:5000${post.featured_image}`}
          alt={post.title}
          className="w-full h-full object-cover"
        />

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="absolute inset-0 flex items-center">

          <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 text-white w-full">

            {/* CATEGORY */}
            <p className="uppercase tracking-[4px] md:tracking-[6px] text-yellow-400 font-semibold text-xs md:text-sm mb-4">
              {post.category}
            </p>

            {/* TITLE */}
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-5">
              {post.title}
            </h1>

            {/* DATE */}
            <p className="text-sm md:text-lg text-gray-200">
              Published on{" "}
              {new Date(post.created_at).toDateString()}
            </p>

          </div>

        </div>

      </div>

      {/* ARTICLE CONTAINER */}
      <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 md:-mt-16 relative z-20 overflow-hidden">

        {/* EXCERPT CARD */}
        <div className="bg-white rounded-[24px] md:rounded-[32px] p-6 md:p-10 shadow-xl border border-gray-100 mb-8 md:mb-12">

          <p className="text-lg md:text-2xl text-gray-700 leading-relaxed italic">
            {post.excerpt}
          </p>

        </div>

        {/* ARTICLE CONTENT */}
        <div className="bg-white rounded-[24px] md:rounded-[32px] p-5 sm:p-6 md:p-10 lg:p-12 shadow-xl border border-gray-100 overflow-hidden">

          <div
  className="
    prose
    prose-sm
    sm:prose-base
    lg:prose-lg
    max-w-none

    overflow-hidden
    break-words

    prose-img:max-w-full
    prose-img:h-auto

    prose-pre:overflow-x-auto
    prose-table:block
    prose-table:overflow-x-auto

    prose-p:break-words
    prose-li:break-words

    prose-headings:text-[#0B1C39]
    prose-p:text-gray-700
    prose-p:leading-relaxed
    prose-a:text-[#0B3D91]
  "
            dangerouslySetInnerHTML={{
              __html: post.content,
            }}
          />

        </div>

      </div>

    </section>
  );
}

export default SingleInsight;